import { Component,Input, ViewChild, ElementRef, OnInit, OnDestroy, Renderer2, ChangeDetectorRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { RouterLink } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule, FormBuilder, FormGroup, ReactiveFormsModule, Validators, AbstractControl } from '@angular/forms';
import validateForm from '../../../../helpers/validateform';
import { AuthService } from '../../../../services/auth.service';
import { UserService } from '../../../../services/user.service';
import { PageTitleService } from '../../../../services/pagetitle.service';
import { EncryptionService } from '../../../../services/encryption.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MenuService } from '../../../../services/menu.service';

declare var bootstrap: any; // 👈 allow Bootstrap JS API usage
@Component({
  selector: 'app-header',
  standalone: true,
  imports: [CommonModule, TranslateModule, FormsModule, ReactiveFormsModule],
  templateUrl: './header.component.html',
  styleUrl: './header.component.css'
})
  
export class HeaderComponent implements OnInit, OnDestroy {
  @ViewChild('btncngPassword') cngButton!: ElementRef;
  @ViewChild('btncngEmail') cngEmailButton!: ElementRef;

  lang: any;
  frmChangePassword!: FormGroup;
  frmChangeEmail!: FormGroup
  isText: boolean = false;
  eyeIcon: string = "bi-eye-slash";
  type: string = "password";
  submitted: boolean = false;
  errorMessage: any;
  successMessage: any;
  titleKey = '';
  userCode: any;
  userName: any;
  userRole: any;
  userConsent: any;
  userEmail: any;
  homeUrl: string = '';
  isMenuOpen: boolean = false;
  private menuSub?: Subscription;
  markedLanguage: boolean = true;
  managePassword: any;
  manageEmail: any;
  private titleSubscription?: Subscription;
  @Input() heading!: string;
  constructor(private formBuilder: FormBuilder, private auth: AuthService, private translate: TranslateService, private user: UserService, private menuService: MenuService, private pageTitle: PageTitleService, private en: EncryptionService, private renderer: Renderer2, private cdr: ChangeDetectorRef) { }
  
  ngOnInit(): void {
    if (typeof window !== 'undefined' && typeof localStorage !== 'undefined') {
      this.lang = localStorage.getItem('site_lang') ?? 'en';
      this.translate.use(this.lang);
      this.markedLanguage = this.lang !== 'en';

      this.userRole = this.auth.getRole();
      if (this.auth.getRole() == 'Staff') {
        this.homeUrl = 'home';
      } else if (this.auth.getRole() == 'Client') {
        this.homeUrl = 'client-associatelist';
      } else if (this.auth.getRole() == 'Rep' || this.auth.getRole() == 'Admin') {
        if (this.auth.getType() == 'C') {
          if (this.auth.getRole() == 'Admin') {
            this.homeUrl = 'admin-home';
          } else {
            this.homeUrl = 'representative-home';
          }
        } else if (this.auth.getType() == 'B' || this.auth.getType() == 'D') {
          this.homeUrl = 'client-associatelist';
        } else if (this.auth.getType() == 'A') {
          this.homeUrl = 'asc-report';
        }
      }
    }

    this.userCode = this.auth.getCode();
    this.userName = this.auth.getName();
    this.userEmail = this.auth.getEmail();
    this.userConsent = this.auth.getConsent();
    this.manageEmail = ['Staff', 'Client'];
    this.managePassword = ['Staff', 'Client'];

    const emailPattern = /^(?!.*\.\.)[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[A-Za-z]{2,}$/;
    this.frmChangePassword = this.formBuilder.group(
      {
        password: ['', Validators.required],
        newPassword: ['', Validators.required],
        retypePassword: ['', Validators.required]
      },
      { validator: this.passwordMatchValidator }
    );
    this.frmChangeEmail = this.formBuilder.group(
      {
        registeredEmail: [''],
        notificationEmail: ['', [Validators.required, Validators.pattern(emailPattern)]],
        retypeNotificationEmail: ['', Validators.required]
      },
      { validator: this.emailMatchValidator }
    );

    // Keep local header state in sync with menu service
    this.menuSub = this.menuService.menuOpen$.subscribe(val => this.isMenuOpen = !!val);
    
    // Subscribe to title changes after forms are initialized to avoid ExpressionChangedAfterItHasBeenCheckedError
    setTimeout(() => {
      this.titleSubscription = this.pageTitle.title$.subscribe(key => {
        this.titleKey = key;
        this.cdr.detectChanges();
      });
    });
  }

  triggerClick() {
    this.cngButton.nativeElement.click();
  }

  triggerEmailClick() {
    this.cngEmailButton.nativeElement.click();
  }
  // passwordMatchValidator(control: AbstractControl): { [key: string]: boolean } | null {
  //   const password = control.get('newPassword')?.value;
  //   const confirmPassword = control.get('retypePassword')?.value;

  //   if (!password || !confirmPassword) {
  //     return null; // don’t validate if fields are empty
  //   }
  //   if (password.length < 8) {
  //     control.get('newPassword')?.setErrors({ minlength: true });
  //     return { minlength: true }; 
  //   }
  //   if (password !== confirmPassword) {
  //     control.get('retypePassword')?.setErrors({ mismatch: true });
  //     return { mismatch: true }; 
  //   } else {
  //     // clear mismatch error if previously set
  //     const errors = control.get('retypePassword')?.errors;
  //     if (errors && (errors['mismatch'] || errors['minlength'])) {
  //       delete errors['mismatch'];
  //       delete errors['minlength'];
  //       if (Object.keys(errors).length === 0) {
  //         control.get('retypePassword')?.setErrors(null);
  //       } else {
  //         control.get('retypePassword')?.setErrors(errors);
  //       }
  //     }
  //     return null; 
  //   }
  // }

  // emailMatchValidator(control: AbstractControl): { [key: string]: boolean } | null {
  //   const email = control.get('notificationEmail')?.value;
  //   const confirmEmail = control.get('retypeNotificationEmail')?.value;

  //   if (!email || !confirmEmail) {
  //     return null; // don’t validate if fields are empty
  //   }
  //   if (email !== confirmEmail) {
  //     control.get('retypeNotificationEmail')?.setErrors({ mismatch: true });
  //     return { mismatch: true }; 
  //   } else {
  //     // clear mismatch error if previously set
  //     const errors = control.get('retypeNotificationEmail')?.errors;
  //     if (errors && (errors['mismatch'])) {
  //       delete errors['mismatch'];
  //       if (Object.keys(errors).length === 0) {
  //         control.get('retypeNotificationEmail')?.setErrors(null);
  //       } else {
  //         control.get('retypeNotificationEmail')?.setErrors(errors);
  //       }
  //     }
  //     return null; 
  //   }
  // }
  
  passwordMatchValidator(control: AbstractControl): null {
    const newPass = control.get('newPassword');
    const retypePass = control.get('retypePassword');

    if (!newPass || !retypePass) return null;

    const password = newPass.value;
    const confirm = retypePass.value;

    const alphaNumRegex = /^(?=.*[A-Za-z])(?=.*\d).*$/;

    let newPassErrors = newPass.errors || {};
    let retypeErrors = retypePass.errors || {};

    /* -----------------------------------
      NEW PASSWORD VALIDATION
    ------------------------------------ */

    // If required error exists → skip custom validation
    if (newPassErrors['required']) {
      newPass.setErrors({ required: true });
      return null;
    }

    // MIN LENGTH
    if (!password || password.length < 6 || password.length >50) {
      newPassErrors['minlength'] = true;
    } else {
      delete newPassErrors['minlength'];
    }

    // ALPHANUMERIC
    if (!alphaNumRegex.test(password)) {
      newPassErrors['alphanumeric'] = true;
    } else {
      delete newPassErrors['alphanumeric'];
    }

    // Apply updated errors
    newPass.setErrors(Object.keys(newPassErrors).length ? newPassErrors : null);

    /* -----------------------------------
      RETYPE PASSWORD VALIDATION
    ------------------------------------ */

    // Skip match validation if required
    if (retypeErrors['required']) {
      retypePass.setErrors({ required: true });
      return null;
    }

    // MATCH CHECK
    if (password && confirm && password !== confirm) {
      retypeErrors['mismatch'] = true;
    } else {
      delete retypeErrors['mismatch'];
    }

    // Apply updated errors
    retypePass.setErrors(Object.keys(retypeErrors).length ? retypeErrors : null);

    return null;
  }
  
  
  emailMatchValidator(control: AbstractControl): null {
    const orgEmail = control.get('registeredEmail');
    const email = control.get('notificationEmail');
    const retype = control.get('retypeNotificationEmail');

    if (!email || !retype) return null;

    const orgEmailVal = orgEmail ? orgEmail.value : null;
    const emailVal = email.value;
    const retypeVal = retype.value;
    if (orgEmailVal) {
      
      if (orgEmailVal === emailVal) {
        // console.log("same")
        email.setErrors({ ...email.errors, samemail: true });  
      } else {
        if (email.errors) {
          delete email.errors['samemail'];
          if (Object.keys(email.errors).length === 0) {
            email.setErrors(null);
          }
        } 
      }
    }

    // Do not run match check if required already failed
    if (retype.errors && retype.errors['required']) return null;

    // Apply mismatch
    if (emailVal && retypeVal && emailVal !== retypeVal) {
      retype.setErrors({ ...retype.errors, mismatch: true });
    } else {
      if (retype.errors) {
        delete retype.errors['mismatch'];
        if (Object.keys(retype.errors).length === 0) {
          retype.setErrors(null);
        }
      }
    }
    return null;
  }
  
  get f() { return this.frmChangePassword.controls; }

  hideShowPass() {    
      this.isText = !this.isText;
      this.isText ? this.eyeIcon = "bi-eye" : this.eyeIcon = "bi-eye-slash";
      this.isText ? this.type = "text" : this.type = "password";
  }

  changePassword() {
    
    // this.submitted = true; 
    if (this.frmChangePassword.invalid) {
      validateForm.validateAllFormFields(this.frmChangePassword);
      alert(this.translate.instant('PleaseFillFormCorrectly'));     
      return;
    }    
    // console.log(this.frmChangePassword.value);
    // return
    // const modalElement = document.getElementById('cngPassword');
    // const modalInstance = bootstrap.Modal.getInstance(modalElement) 
                                    // || new bootstrap.Modal(modalElement);
    this.frmChangePassword.value.password = this.en.encryptUsingAES256(this.frmChangePassword.value.password);
    this.frmChangePassword.value.newPassword = this.en.encryptUsingAES256(this.frmChangePassword.value.newPassword);
    this.frmChangePassword.value.retypePassword = this.en.encryptUsingAES256(this.frmChangePassword.value.retypePassword);
    // console.log(this.frmChangePassword.value);
    // return;
    this.user.changePassword(this.frmChangePassword.value)
      .subscribe({
          next: (res:any) => {
            // alert(res.message);
            if (res.status) {              
              this.errorMessage = '';
              this.successMessage = res.message;
              this.frmChangePassword.reset();
              
              // modalInstance.hide();
              // document.getElementById("cngPassword")?.click();
              this.triggerClick();
              alert(res.message); 
              // Force re-authentication after password change.
              this.logout();
              return;
            } else {
              this.errorMessage = res.message;
              // modalInstance.hide();
              // this.triggerClick();
              alert(res.message);
              if(res.data == 2)
                this.frmChangePassword.patchValue({ password: '' });
              if(res.data == 3)
                this.frmChangePassword.patchValue({ newPassword: '', retypePassword: '' });
              if (res.data == 0)
                this.frmChangePassword.patchValue({ newPassword: '', retypePassword: '' });
            }
            this.submitted = false;
          },
          error: (err: any) => {
            if (err.status == 401) {
              this.logout();
			        return
            }
              alert(err.error.message);        
              this.successMessage = '';
              this.errorMessage = err?.error.message;
          }
        });
  }
  
  changeEmail() {
    
    this.submitted = true; 
    if (this.frmChangeEmail.invalid) {
      validateForm.validateAllFormFields(this.frmChangeEmail);
      // this.frmChangeEmail.markAllAsTouched(); 
      alert(this.translate.instant('PleaseFillFormCorrectly'));     
      return;
    }
   
    const newMail = this.frmChangeEmail.value.notificationEmail;

    const confirmMsg = this.translate.instant(
    'CONFIRM_CHANGE_EMAIL',
    { email: newMail }
  );
     const confirmed = confirm(confirmMsg);

    if (!confirmed) {
      this.submitted = false;
      return;
    }
    // const modalElement = document.getElementById('cngEmail');
    // const modalInstance = bootstrap.Modal.getInstance(modalElement) 
    //   || new bootstrap.Modal(modalElement);
    // console.log(this.frmChangeEmail.value);
    // return
    this.user.changeEmail(this.frmChangeEmail.value)
      .subscribe({
          next: (res:any) => {
            // alert(res.message);
            if (res.status) {              
              this.errorMessage = '';
              this.successMessage = res.message;
              this.frmChangeEmail.reset();
              this.user.clearUserProfileCache();
              // this.frmChangeEmail.patchValue({ registeredEmail: newMail });
              // this.auth.storeEmail(newMail);
              // modalInstance.hide();
              // document.getElementById("btncngEmail")?.click();
              this.triggerEmailClick();
              alert(res.message);   
            } else {
              this.errorMessage = res.message;
              // modalInstance.hide();
              // document.getElementById("btncngEmail")?.click();
              // this.triggerEmailClick();
              alert(res.message);              
            }
            this.submitted = false;
          },
          error: (err: any) => {
            if (err.status == 401) {
              this.logout();
              return;
            }
              alert(err.error.message);        
              this.successMessage = '';
              this.errorMessage = err?.error.message;
          }
        });
  }

  genEmailPop() {
    this.user.getUserProfile().subscribe({
      next: (res: any) => { 
        if (res.status) {
          // this.auth.storeEmail(res.data.email2);
          // this.frmChangeEmail.value.registeredEmail = 'aa@aa.com';//res.data.email2;
          this.frmChangeEmail.patchValue({
            registeredEmail: res.data.email2
          });
          const modalEl = document.getElementById('cngEmail');
          const modal = new bootstrap.Modal(modalEl);
          modal.show();
        } 
      },
      error: (err: any) => {
        if (err.status == 401) {
          this.logout();
          return
        }
        alert("Something went wrong. Please try again")
      }
    })
  }

  logout() {
    this.auth.logout();
  }

  toggleMenu() {
    this.isMenuOpen = !this.isMenuOpen;
    this.menuService.toggleMenu();
  }

  ngOnDestroy(): void {
    this.menuSub?.unsubscribe();
    this.titleSubscription?.unsubscribe();
  }

  cngLang() {
    // this.auth.refreashToken()
    //   .subscribe({
    //     next: (res: any) => {
    //       console.log(res)
    //       if (res.status) {
    //         // Token refreshed successfully
    //         this.auth.storeToken(res.data.token);
    //       } else {
    //         alert(res.message);
    //       }
    //     },
    //     error: (err: any) => {
    //       if (err.status == 401) {
    //         this.logout();
    //         return
    //       } else {
    //         alert(err.error.message);
    //       }
    //     }
    //   });
    if (this.markedLanguage) {
      // console.log('Checkbox is checked:', this.markedLanguage);
      localStorage.setItem('site_lang', 'jp');
      // console.log(localStorage.getItem('site_lang'));
      this.translate.use('jp');
      this.renderer.addClass(document.body, 'body-jp-class');
    } else {
      localStorage.setItem('site_lang', 'en');
      // console.log(localStorage.getItem('site_lang'));
      this.translate.use('en');
      this.renderer.removeClass(document.body, 'body-jp-class');
    }

  }
}
